export default __webpack_public_path__ + "static/O0062-b604addec0db2c485e2b70e4ab4a7220.png";